import { useEffect, useState } from 'react'
import { EeocsQueryVariables, EnumEeocStatus, PositionsQueryVariables } from 'src/gql/graphql'
import { FilterValues, FiltersProps } from '.'
import { ButtonProps } from 'reactstrap'

export interface UseFilterStateResults {
  filterProps: FiltersProps
  defaultFilters: FilterValues
  queryFilters: PositionsQueryVariables['filter']
  buttonColor: ButtonProps['color']
}

const LOCAL_STORAGE_KEY = 'eeoc-list-filters'

const useFilterState = (): UseFilterStateResults => {
  const [filtersOpen, setFiltersOpen] = useState(false)
  const toggleFilters = (): void => setFiltersOpen(o => !o)
  const storage = localStorage.getItem(LOCAL_STORAGE_KEY)
  const defaultFilters: FilterValues = {
    status: EnumEeocStatus.Signed
  }
  const filterStorage = storage !== null
    ? JSON.parse(storage)
    : {}
  const [filters, setFilters] = useState<FilterValues>(
    Object.assign({}, defaultFilters, filterStorage)
  )
  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(filters))
  }, [filters])
  const hasFilterValues = Object.values(filters).some((value) => value.length > 0)
  const buttonColor: ButtonProps['color'] = hasFilterValues ? 'success' : 'light'
  const queryFilters: EeocsQueryVariables['filter'] = {
    status: filters.status
  }
  const handleFilterChange: FiltersProps['onSubmit'] = (values) => setFilters(values)
  return {
    filterProps: {
      isOpen: filtersOpen,
      toggleOpen: toggleFilters,
      onSubmit: handleFilterChange,
      initialState: filters,
      defaultFilters
    },
    defaultFilters,
    queryFilters,
    buttonColor
  }
}

export default useFilterState
